import GET_HOME_VIDEO_BY_ID from "./getHomeVideoById"
import GET_HOME_VIDEOS from "./getHomeVideos"
import SEARCH_HOME_VIDEOS from "./searchHomeVideos"

export default {
  GET_HOME_VIDEOS,
  GET_HOME_VIDEO_BY_ID,
  SEARCH_HOME_VIDEOS
}
